import React, { useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";

import { FormField } from "../../../../sharedComponents/formField";
import DropZone from "../../../../sharedComponents/dropZoneWrap";
import { getSources, addImages } from "../../../../store/actions";
import { required } from "../../../../constants/formValidators";

const ImagesDropZone = ({ toggleAddImagePanel, sourceList, handleSubmit, addImages, addedImage, resetForm }) => {
	const notify = (msg) => {
		switch (msg.type) {
			case "error":
				return NotificationManager.error(msg.text, "", 5000);
			case "success":
				return NotificationManager.success(msg.text, "", 5000);
			default:
			// do nothing
		}
	};

	const [dropZoneFiles, updateDropZoneFiles] = useState([]);
	const [resetDropZone, setResetDropZone] = useState(0);
	const [submitting, setSubmitting] = useState(false);

	const validateForm = (values) => {
		setSubmitting(true);
		if (dropZoneFiles && dropZoneFiles.length) {
			const dzFile = dropZoneFiles[0].file;
			const formData = new FormData();
			formData.append("name", values.name);
			formData.append("source", values.source);
			formData.append("photo_o", dzFile, dzFile.name);

			const successHandler = (event) => {
				event.json().then((data) => addedImage(data, values.seq));
				setResetDropZone(resetDropZone + 1);
				resetForm("ImagesDropZone");
				toggleAddImagePanel(false);
			};

			addImages(formData, successHandler);
		} else {
			NotificationManager.error("Please upload one image", "", 5000);
		}
	};

	return (
		<form className="panel-tab-content" onSubmit={handleSubmit(validateForm)}>
			<div className="flex-fill">
				<DropZone
					alert={notify}
					accepts={["jpeg", "jpg", "png", "gif", "bmp"]}
					onAdd={(files) => {
						updateDropZoneFiles(files);
						files && files.length && setSubmitting(false);
					}}
					forceReset={resetDropZone}
				/>
				<div className="row">
					<Field
						label="Seq"
						name="seq"
						type="number"
						formGroupClass="col-2 pr-0"
						component={FormField}
						validate={[required]}
						min="0"
						onChange={() => setSubmitting(false)}
					/>
					<Field
						label="Name"
						name="name"
						type="text"
						formGroupClass="col-5 pr-0"
						component={FormField}
						validate={[required]}
						onChange={() => setSubmitting(false)}
					/>
					<Field
						label="Source"
						name="source"
						type="select"
						options={sourceList}
						formGroupClass="col-5"
						component={FormField}
						validate={[required]}
						onChange={() => setSubmitting(false)}
					/>
				</div>
			</div>
			<div className="pt-4 pb-4 sticky-footer">
				<div className="text-right">
					<button className="btn btn-default" type="button" onClick={() => toggleAddImagePanel(false)}>
						Cancel
					</button>
					<button className="btn btn-primary-dark" type="submit" disabled={submitting}>
						Add Image
					</button>
				</div>
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	return {
		sourceList: get(state, "AddRecipe.sourceList", [])
	};
};

const mapDispatchToProps = {
	getSources,
	addImages,
	resetForm: reset
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "ImagesDropZone",
		enableReinitialize: true
	})(ImagesDropZone)
);
